<h1 mat-dialog-title>{{ 'companies.detail.editPhonebookContactDialog.title' | translate }} - 
  {{ 'common.createdAt' | translate }} {{ createdAt | date}}
</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div class="form-wrapper mt-3">
    <form [formGroup]="form" (ngSubmit)="onFormSubmit(model)">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
      <div class="row mb-1">
        <div class="col-12 col-md-6">
          <mat-spinner-button *ngIf="loggedUserRoleType === 'master' || loggedUserRoleType === 'collaborator'" 
            role="submit" [options]="formBtnOptions" class="btn-elevate">
          </mat-spinner-button>
          <a mat-raised-button color="accent" (click)="onAddCommunication()"
            *ngIf="loggedUser && loggedUserPermissions.includes('canCreateCommunications') && this.data.phonebookContact.email !== ''
              && (loggedUserRoleType === 'master' || loggedUserRoleType === 'collaborator')"
            matTooltip="{{ 'companies.detail.phonebookTab.newMessageTooltip' | translate }}" class="ml-2">
            {{ 'companies.detail.editPhonebookContactDialog.newMessage' | translate }}
            <mat-icon fontSet="fal" fontIcon="fa-envelope"></mat-icon>
          </a>
        </div> <!-- /.col -->
        <div class="col-12 col-md-6 text-left">
          <a mat-button mat-raised-button mat-default (click)="onClose()">{{ 'common.cta.close' | translate }}</a>
        </div> <!-- /.col -->
      </div> <!-- /.row -->
    </form>
  </div> <!-- /.form-wrapper -->
</mat-dialog-content> <!-- mat-dialog-content -->